import React from "react";
import Translation from "../i18n";

class Register extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            invalidEmail: true,
            invalidForm: true,
            name: false,
            email: false,
            confirm: false,
			purchased: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.isValidEmail = this.isValidEmail.bind(this);
		this.isPurchased = this.isPurchased.bind(this);
        this.isRegistered = this.isRegistered.bind(this);
        this.getData = this.getData.bind(this);
        this.setData = this.setData.bind(this);
        this.confirm = this.confirm.bind(this);
    }

	isPurchased() {
		const {questionnaireId} = this.props;
		fetch(`/api/survey/show/${questionnaireId}`, {method: 'GET', redirect: 'follow'})
			.then(response => response.json())
			.then(result => {
				if(result && result.response === false) {
					this.setState({purchased: true})
				} else {
					localStorage.setItem('mm-name', `${result.firstname} ${result.lastname}`);
					localStorage.setItem('mm-email', `${result.email}`);
					this.setState({purchased: true}, () => {
						this.confirm();
					});
				}
			})
			.catch(error => {
				this.setState({purchased: true})
			});
	}

    isRegistered() {
		let name = localStorage.getItem('mm-name');
		let email = localStorage.getItem('mm-email');
		return (!(name === null && email === null));
    }

    getData(identifier) {
        return localStorage.getItem(identifier);
    }

    confirm() {
        this.props.setNameReplacement(this.getData('mm-name'));
        this.setState({confirm: true});
    }

    setData() {
        localStorage.setItem('mm-name', this.state.name);
        localStorage.setItem('mm-email', this.state.email);
        this.confirm()
    }

    isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    handleChange(event) {
        if(event.target.id === 'email') {
            if(!this.isValidEmail(event.target.value)) {
                this.setState({invalidEmail: true});
                this.setState({email: false});
            } else {
                this.setState({invalidEmail: false});
                this.setState({email: event.target.value});
            }
        }
        if(event.target.id === 'name') {
            if(event.target.value === '') {
                this.setState({invalidForm: true});
                this.setState({name: false});
            } else {
                this.setState({invalidForm: false});
                this.setState({name: event.target.value});
            }
        }
        localStorage.clear();
    };

	componentDidMount() {
		this.isPurchased()
	}

	render() {
        return (
            <>
                {!this.state.confirm && this.state.purchased &&
                    <div className="fetch-progress">
                        <div className="fetch-progress-wrapper">
                            <div className="row align-items-center h-100">
                                <div className="col-md-4 mx-auto">
                                    <div className="d-block p-4">
                                        <h1 className="text-primary mb-4 text-center">
                                            {!this.isRegistered() &&
                                                <Translation i18n="isRegistered"/>
                                            }
                                            {this.isRegistered() &&
                                                <Translation i18n="isThatYou" />
                                            }
                                        </h1>
                                        {this.isRegistered() &&
                                            <p className="text-primary text-center mt-n4 mb-4">
                                                <Translation i18n="unless" />
                                            </p>
                                        }
                                        <form>
                                            <div className="mb-3">
                                                <span className="text-center d-block mb-2">
                                                    <Translation i18n="yourNamePlease" />:
                                                </span>
                                                <input type="name" className="form-control" id="name"
                                                       placeholder="Name"
                                                       onChange={this.handleChange}
                                                       defaultValue={this.isRegistered() ? this.getData('mm-name') : ''} />
                                            </div>
                                            <div className="mb-3">
                                                <span className="text-center d-block mb-2">
                                                    <Translation i18n="yourMailPlease" />:
                                                </span>
                                                <input type="email"
                                                       className={'form-control' + (this.isRegistered() ? '' : this.state.invalidEmail ? ' is-invalid' : '')}
                                                       id="email" placeholder="E-Mail"
                                                       onChange={this.handleChange}
                                                       defaultValue={this.isRegistered() ? this.getData('mm-email') : ''} />
                                                {this.state.invalidEmail &&
                                                    <div className="invalid-feedback">
                                                        <Translation i18n="correctMail" />
                                                    </div>
                                                }
                                            </div>
                                            <div className="mb-3">
                                                <button id="registerBtn" type="button" className="btn btn-primary d-block w-100"
                                                        disabled={this.isRegistered() ? false : this.state.invalidForm ? (this.state.invalidEmail) : (this.state.invalidEmail)}
                                                        onClick={this.isRegistered() ? () => this.confirm() : () => this.setData()}>{this.isRegistered() ? <Translation i18n="yesIam" /> : <Translation i18n="continue" />}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>

        );
    }
}

export default Register;
